import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Protected from "@/components/Protected";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Timesheet from "@/pages/Timesheet";
import Breaks from "@/pages/Breaks";
import Absences from "@/pages/Absences";
import Expenses from "@/pages/Expenses";
import Reports from "@/pages/Reports";
import AdminApprovals from "@/pages/AdminApprovals";
import AdminUsers from "@/pages/AdminUsers";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminProjects from "@/pages/AdminProjects";
import AdminProjectDetail from "@/pages/AdminProjectDetail";
import AdminData from "@/pages/AdminData";
import AdminAbsencesMatrix from "@/pages/AdminAbsencesMatrix";
import AdminInvoices from "@/pages/AdminInvoices";
import AdminExpenses from "@/pages/AdminExpenses";
import AdminSupplierInvoices from "@/pages/AdminSupplierInvoices";
import AdminSettings from "@/pages/AdminSettings";
import Manual from "@/pages/Manual";

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                element={
                    <Protected>
                        <Layout />
                    </Protected>
                }
            >
                <Route path="/" element={<Dashboard />} />
                <Route path="/timesheet" element={<Timesheet />} />
                <Route path="/breaks" element={<Breaks />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/absences" element={<Absences />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/manual" element={<Manual />} />
                <Route
                    path="/admin/approvals"
                    element={
                        <Protected adminOnly allowPm>
                            <AdminApprovals />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/users"
                    element={
                        <Protected adminOnly>
                            <AdminUsers />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/customers"
                    element={
                        <Protected adminOnly>
                            <AdminCustomers />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/projects"
                    element={
                        <Protected adminOnly>
                            <AdminProjects />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/projects/:projectId"
                    element={
                        <Protected adminOnly>
                            <AdminProjectDetail />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/data"
                    element={
                        <Protected adminOnly>
                            <AdminData />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/expenses"
                    element={
                        <Protected adminOnly>
                            <AdminExpenses />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/absences-matrix"
                    element={
                        <Protected adminOnly>
                            <AdminAbsencesMatrix />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/invoices"
                    element={
                        <Protected adminOnly allowPm>
                            <AdminInvoices />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/supplier-invoices"
                    element={
                        <Protected adminOnly>
                            <AdminSupplierInvoices />
                        </Protected>
                    }
                />
                <Route
                    path="/admin/settings"
                    element={
                        <Protected adminOnly>
                            <AdminSettings />
                        </Protected>
                    }
                />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
